import React, { useState } from "react";
import { connect } from "react-redux";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  doc,
  setDoc,
  collection,
  getFirestore,
  updateDoc,
} from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useFetchTopics from "../cofig/fectchtopichook";

function Topics(props) {
  const [catg, setcatg] = React.useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  let [errorText, seterrorText] = useState('')
  let [loading, setLoading] = useState(false);
  let [loading_content, setLoadingContent] = useState("");
  const { topics, loading: topicsLoading, error } = useFetchTopics();


  const proceed = async () => {


    seterrorText('')

    if (catg.length == 0) {
      seterrorText('Select atleast one Topic')
      return
    }

    setLoading(true);
    setLoadingContent("Uploading Your Profile Data....");
    const db = getFirestore();
    await updateDoc(doc(db, "teachers", location.state), {
      topics: catg,
    }).then(() => {
      setLoadingContent("Almost Done.");

      setTimeout(() => {
        setLoading(true);
        setLoadingContent("");
        navigate("/TeacherDashboard");
      }, 2000);
    });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      {loading ? (
        <>
          <div class="loading" id="loading">
            Loading&#8230;
          </div>

          <div className="progressDiv mt-5">
            <h3 >Loading</h3>
            <br />
            <p>{loading_content}</p>
          </div>
        </>
      ) : (
        ""
      )}

      <div
        style={{ marginTop: 20 }}
        className="
      flex flex-col
      bg-white
      shadow-md
      px-4
      sm:px-6
      md:px-8
      lg:px-10
      py-8
      rounded-3xl
      w-90
      max-w-md
      align-items-center
      justify-content-start"
      >
        <div className="font-medium self-center text-xl sm:text-3xl text-gray-800">
          Select Topics
        </div>
        <div className="mt-4 self-center text-xl sm:text-sm text-gray-800">
          Enter your User credentials to access your account
        </div>


        <div className="mt-10" style={{ width: "100%" }}>

          <div
            style={{ width: "100%" }}
            className=" flex flex-row mb-3  flex-wrap justify-content-start align-items-start"
          >


            <div style={{ width: "100%" }}>
              {topicsLoading ? (
                <div>Loading Topics...</div>
              ) : error ? (
                <div>{error}</div>
              ) : (
                topics.map((topic, index) => (
                  <div key={index} style={{ width: "100%" }}>
                    <div className="form-check text-wrap">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={topic}
                        id={`topic-${index}`}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setcatg((prev) => [...prev, topic]);
                          } else {
                            setcatg((prev) => prev.filter(item => item !== topic));
                          }
                        }}
                      />
                      <label
                        className="form-check-label text-wrap break-words"
                        htmlFor={`topic-${index}`}
                        style={{
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {topic}
                      </label>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          <p style={{ color: 'red' }}>
            {errorText}
          </p>

          <div className="flex w-full">
            <button
              onClick={() => {
                proceed();
              }}
              className="
              flex
              mt-2
              items-center
              justify-center
              focus:outline-none
              text-white text-sm
              sm:text-base
              bg-blue-500
              hover:bg-blue-600
              rounded-2xl
              py-2
              w-full
              transition
              duration-150
              ease-in"
            >
              <span className="mr-2 uppercase">Proceed</span>
              <span>
                <svg
                  className="h-6 w-6"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
            </button>




          </div>

        </div>
      </div>
      <div
        className="flex justify-center items-center mt-6"
        style={{ marginBottom: 50 }}
      >
        <a
          href="#"
          target="_blank"
          className="
        inline-flex
        items-center
        text-gray-700
        font-medium
        text-xs text-center
      "
        ></a>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    name: state.name,
  };
};

export default connect(mapStateToProps, null)(Topics);
